import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  loading: {
    position: 'relative',
    margin: 'auto',
  },
}));

export default useStyles;
